const createFormSuccessMsg = (form) => {
  const msg = document.createElement("p");
  msg.classList.add("form-success-msg");
  msg.innerHTML = "Product is added to cart";
  form.appendChild(msg);
  setTimeout(() => {
    msg.remove();
  }, 3000);
};
const formQty = (form) => {
  const qty = form.querySelector(".quantity-selector__wrapper");
  const qtyInput = qty.querySelector("input");
  const qtyBtns = qty.querySelectorAll("button");
  const qtyPlus = qty.querySelector(".qty-selector__btn--plus");
  const qtyMinus = qty.querySelector(".qty-selector__btn--minus");
  qtyPlus.addEventListener("click", () => {
    qtyInput.value++;
  });
  qtyMinus.addEventListener("click", () => {
    if (qtyInput.value > 1) {
      qtyInput.value--;
    }
  });
};

const relatedProductsMobileQty = () => {
  const relatedProducts = document.querySelectorAll(
    ".meta-related-products-mob__product"
  );
  relatedProducts.forEach((relatedProduct) => {
    const relatedProductQty = relatedProduct.querySelectorAll(
      ".quantity-selector__wrapper"
    );
    relatedProductQty.forEach((qty) => {
      const qtyInput = qty.querySelector("input");
      const qtyBtns = qty.querySelectorAll("button");
      const qtyPlus = qty.querySelector(".qty-selector__btn--plus");
      const qtyMinus = qty.querySelector(".qty-selector__btn--minus");
      qtyPlus.addEventListener("click", () => {
        qtyInput.value++;
      });
      qtyMinus.addEventListener("click", () => {
        if (qtyInput.value > 1) {
          qtyInput.value--;
        }
      });
    });
  });
};

const fetchCart = async () => {
  var cartContents = await fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  const cartCount = document.querySelector(".site-header-cart--count.visible");
  if (cartCount === null) {
    return;
  }
  cartCount.setAttribute("data-header-cart-count", cartContents.item_count);
};

const ajaxAddToCart = async (form) => {
  const url = form.action;
  const data = new FormData(form);
  await fetch(url, {
    method: "POST",
    body: data,
  }).then(async (response) => {
    await fetchCart();
    createFormSuccessMsg(form);
  });
};

const atcBanner = (productData, cartData) => {
  const atcBanner = document.querySelector("[data-atc-banner]");
  if (atcBanner === null) {
    return;
  }
  const clonedAtcBanner = atcBanner.cloneNode(true);
  const header = document.querySelector(".site-header");
  header.appendChild(clonedAtcBanner);

  window.addEventListener("click", (e) => {
    if (e.target.closest("[data-atc-banner]")) {
      return;
    }
    clonedAtcBanner.dataset.animationState = "close";

    header.querySelector("[data-atc-banner]") !== null &&
      header.removeChild(clonedAtcBanner);
  });
  const closeBtn = clonedAtcBanner.querySelector("[data-atc-banner-close]");
  closeBtn.addEventListener("click", () => {
    clonedAtcBanner.dataset.animationState = "close";
    header.querySelector("[data-atc-banner]") !== null &&
      header.removeChild(clonedAtcBanner);
  });
  clonedAtcBanner.dataset.animationState = "open";
  const bannerImage = clonedAtcBanner.querySelector(".atc--product-image");
  const bannerTitle = clonedAtcBanner.querySelector(
    "[data-atc-banner-product-title]"
  );
  const bannerQty = clonedAtcBanner.querySelector(
    "[data-atc-banner-product-price-quantity]"
  );
  const bannerPrice = clonedAtcBanner.querySelector(
    "[data-atc-banner-product-price-value]"
  );

  const bannerSubtotal = clonedAtcBanner.querySelector(
    "[data-atc-banner-cart-subtotal]"
  );

  const cartItems = clonedAtcBanner.querySelector(
    "[data-atc-banner-cart-button] span"
  );

  bannerTitle.innerHTML = productData.title;
  bannerImage.innerHTML = `<img src="${productData.image}" alt="${productData.title}">`;
  bannerQty.innerHTML = `${productData.qty} × `;
  bannerPrice.innerHTML = productData.price;

  bannerSubtotal.innerHTML = Shopify.formatMoney(cartData.items_subtotal_price);
  cartItems.innerHTML = cartData.item_count;
};

const getProductData = (form) => {
  let productRow = form.closest(".meta-related-products__product");
  if (productRow === null) {
    productRow = form.closest(".meta-related-products-mob__product");
  }
  const productImage = productRow.querySelector("img");
  const productTitle = productRow.querySelector(
    ".meta-related-products__product-title a"
  );
  const productQty = productRow.querySelector(".quantity-selector__input");
  const productPrice = productRow.querySelector(
    ".meta-related-products__product-price"
  );
  const productData = {
    image: productImage.src,
    title: productTitle.textContent,
    qty: productQty.value,
    price: productPrice.textContent,
  };
  return productData;
};

const getCartData = async () => {
  const cartData = await fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  return cartData;
};

const descButtonHandler = () => {
  // console.log("JA RADIm");
  const descBtn = document.querySelector(".js-prod-desc-btn");
  // console.log("desc button", descBtn);
  if (descBtn === null) {
    return;
  }

  descBtn.addEventListener("click", () => {
    descBtn.classList.toggle("is-read-more");
    const btnContent = descBtn.textContent.toLowerCase().trim();
    btnContent == "read more..."
      ? (descBtn.textContent = "Read Less...")
      : (descBtn.textContent = "Read More...");
  });
};

window.addEventListener("DOMContentLoaded", () => {
  // quickBtnsClogic();
  relatedProductsMobileQty();
  // addToCart();

  descButtonHandler();
});

window.addEventListener("DOMContentLoaded", () => {
  if (window.screen.width > 1023) {
    const megaMenuLinks = document.querySelectorAll(
      ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2 .navmenu-link.navmenu-link-parent"
    );
    megaMenuLinks.forEach((link) => {
      const computedBorderWidth = getComputedStyle(link).borderWidth;
      link.style.marginLeft = "-" + computedBorderWidth;
      link.style.marginTop = "-" + computedBorderWidth;
    });

    const megaMenuLinksParents = document.querySelectorAll(
      ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2"
    );
    megaMenuLinksParents.forEach((parent) => {
      const link = parent.querySelector(".navmenu-link.navmenu-link-parent");
      !link.nextElementSibling.classList.contains(".navmenu-link-parent") &&
        (link.style.marginTop = "0px");
    });

    const ulMains = document.querySelectorAll(
      ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2"
    );
    ulMains.forEach((ulMain) => {
      const megaMenuLink = document.querySelector(
        ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2 .navmenu-link.navmenu-link-parent"
      );
      const computedBorderWidth = getComputedStyle(megaMenuLink).borderWidth;
      ulMain.style.margin = computedBorderWidth;
      console.log(computedBorderWidth);
    });
    const navbar = document.querySelector(".site-navigation");
    const navbarWidth = window.getComputedStyle(navbar).width;
    const navbarMargin = window.getComputedStyle(navbar).marginLeft;
    const megaMenuWrapper = document.querySelectorAll(
      ".navmenu-meganav.navmenu-meganav--desktop"
    );
    megaMenuWrapper.forEach((item) => {
      item.style.width = navbarWidth;
      item.style.left = navbarMargin;
    });
  }
});
window.addEventListener("resize", () => {
  if (window.screen.width > 1023) {
    const megaMenuLinks = document.querySelectorAll(
      ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2 .navmenu-link.navmenu-link-parent"
    );

    megaMenuLinks.forEach((link) => {
      const computedBorderWidth = getComputedStyle(link).borderWidth;
      link.style.marginLeft = "-" + computedBorderWidth;
      link.style.marginTop = "-" + computedBorderWidth;
    });

    const megaMenuLinksParents = document.querySelectorAll(
      ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2"
    );
    megaMenuLinksParents.forEach((parent) => {
      const link = parent.querySelector(".navmenu-link.navmenu-link-parent");
      !link.nextElementSibling.classList.contains(".navmenu-link-parent") &&
        (link.style.marginTop = "0px");
    });

    const ulMains = document.querySelectorAll(
      ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2"
    );
    ulMains.forEach((ulMain) => {
      const megaMenuLink = document.querySelector(
        ".site-navigation .navmenu-meganav.navmenu-meganav--desktop .navmenu-multi-column-items .navmenu-depth-2 .navmenu-link.navmenu-link-parent"
      );
      const computedBorderWidth = getComputedStyle(megaMenuLink).borderWidth;
      ulMain.style.margin = computedBorderWidth;
      console.log(computedBorderWidth);
    });
    const navbar = document.querySelector(".site-navigation");
    const navbarWidth = window.getComputedStyle(navbar).width;
    const navbarMargin = window.getComputedStyle(navbar).marginLeft;
    const megaMenuWrapper = document.querySelectorAll(
      ".navmenu-meganav.navmenu-meganav--desktop"
    );
    megaMenuWrapper.forEach((item) => {
      item.style.width = navbarWidth;
      item.style.left = navbarMargin;
    });
  }
});

const vatContainer = document.querySelector('.vat-toggle-container'); // Cached parent for font-weight styles
const vatToggle = document.querySelector('.vat-toggle');
const vatToggleSlider = document.querySelector('.vat-toggle__slider');
let vatIncluded;

if('vatIncluded' in sessionStorage) {
  vatIncluded = sessionStorage.getItem('vatIncluded');
}
else {
  sessionStorage.setItem('vatIncluded', 'false');
}


if(vatToggle && vatToggleSlider) {
  vatToggle.addEventListener('click', () =>{
    if(vatIncluded == 'true') {
      vatIncluded = 'false';
      sessionStorage.setItem('vatIncluded', 'false');
      vatToggleSlider.classList.toggle('included');
      if (vatContainer) vatContainer.classList.remove('vat-active'); // Update structural style state
    }
    else {
      vatIncluded = 'true';
      sessionStorage.setItem('vatIncluded', 'true');
      vatToggleSlider.classList.toggle('included');
      if (vatContainer) vatContainer.classList.add('vat-active'); // Update structural style state
    }
    
    updateVATPrices();
    updateVolumePricingTables();

    // Call the sync function here
    syncSamiWithVAT(vatIncluded); 
  });
}

function updateSwitch() {
  if('vatIncluded' in sessionStorage) vatIncluded = sessionStorage.getItem('vatIncluded');
  else vatIncluded = 'false';

  if(vatIncluded == 'true') {
    vatToggleSlider.classList.add('included');
  }
  else{
    vatToggleSlider.classList.remove('included');
  }
}

// function updateVATPrices(){
//   const prices = document.querySelectorAll('.prices-container');

//   if('vatIncluded' in sessionStorage) vatIncluded = sessionStorage.getItem('vatIncluded');
//   else vatIncluded = 'false';

//   if(vatIncluded == 'true'){
//     prices.forEach((price) => {
//       const incVatPrice = price.querySelector('.price__inc-vat');
//       const exVatPrice = price.querySelector('.price__ex-vat');
      

//       incVatPrice.classList.add('price-vat--primary');
//       incVatPrice.classList.remove('price-vat--secondary');
//       exVatPrice.classList.add('price-vat--secondary');
//       exVatPrice.classList.remove('price-vat--primary');
//       price.classList.remove('prices-container--fliped');
//     });
//   }
//   else{
//     prices.forEach((price) => {
//       const incVatPrice = price.querySelector('.price__inc-vat');
//       const exVatPrice = price.querySelector('.price__ex-vat');
      

//       incVatPrice.classList.add('price-vat--secondary');
//       incVatPrice.classList.remove('price-vat--primary');
//       exVatPrice.classList.add('price-vat--primary');
//       exVatPrice.classList.remove('price-vat--secondary');

//       price.classList.add('prices-container--fliped');
//     });
//   }
// }

function updateVATPrices() {
  const prices = document.querySelectorAll('.prices-container');

  if ('vatIncluded' in sessionStorage) vatIncluded = sessionStorage.getItem('vatIncluded');
  else vatIncluded = 'false';

  if (vatIncluded == 'true') {
    prices.forEach((price) => {
      const incVatPrice = price.querySelector('.price__inc-vat');
      const exVatPrice = price.querySelector('.price__ex-vat');

      incVatPrice.classList.add('price-vat--primary');
      incVatPrice.classList.remove('price-vat--secondary');
      exVatPrice.classList.add('price-vat--secondary');
      exVatPrice.classList.remove('price-vat--primary');
      
      // REMOVE flip: Inc VAT stays on top
      price.classList.remove('prices-container--fliped'); 
    });
  } else {
    prices.forEach((price) => {
      const incVatPrice = price.querySelector('.price__inc-vat');
      const exVatPrice = price.querySelector('.price__ex-vat');

      incVatPrice.classList.add('price-vat--secondary');
      incVatPrice.classList.remove('price-vat--primary');
      exVatPrice.classList.add('price-vat--primary');
      exVatPrice.classList.remove('price-vat--secondary');
      
      // ADD flip: Ex VAT moves to top, Inc VAT moves to bottom
      price.classList.add('prices-container--fliped'); 
    });
  }
}

// function updateSingularVATPrice(element){
//   if('vatIncluded' in sessionStorage) vatIncluded = sessionStorage.getItem('vatIncluded');
//   else vatIncluded = 'false';

//   const container = element.querySelector('.prices-container');

//   if(vatIncluded == 'true'){
//     const incVatPrice = container.querySelector('.price__inc-vat');
//     const exVatPrice = container.querySelector('.price__ex-vat');

//     incVatPrice.classList.add('price-vat--primary');
//     incVatPrice.classList.remove('price-vat--secondary');
//     exVatPrice.classList.add('price-vat--secondary');
//     exVatPrice.classList.remove('price-vat--primary');
//     container.classList.remove('prices-container--fliped');
//   }
//   else{
//     const incVatPrice = container.querySelector('.price__inc-vat');
//     const exVatPrice = container.querySelector('.price__ex-vat');

//     incVatPrice.classList.add('price-vat--secondary');
//     incVatPrice.classList.remove('price-vat--primary');
//     exVatPrice.classList.add('price-vat--primary');
//     exVatPrice.classList.remove('price-vat--secondary');
//     container.classList.add('prices-container--fliped');
//   }
// }

function updateSingularVATPrice(element) {
  if ('vatIncluded' in sessionStorage) vatIncluded = sessionStorage.getItem('vatIncluded');
  else vatIncluded = 'false';

  const container = element.querySelector('.prices-container');

  if (vatIncluded == 'true') {
    const incVatPrice = container.querySelector('.price__inc-vat');
    const exVatPrice = container.querySelector('.price__ex-vat');

    incVatPrice.classList.add('price-vat--primary');
    incVatPrice.classList.remove('price-vat--secondary');
    exVatPrice.classList.add('price-vat--secondary');
    exVatPrice.classList.remove('price-vat--primary');
    
    // REMOVE flip
    container.classList.remove('prices-container--fliped');
  } else {
    const incVatPrice = container.querySelector('.price__inc-vat');
    const exVatPrice = container.querySelector('.price__ex-vat');

    incVatPrice.classList.add('price-vat--secondary');
    incVatPrice.classList.remove('price-vat--primary');
    exVatPrice.classList.add('price-vat--primary');
    exVatPrice.classList.remove('price-vat--secondary');
    
    // ADD flip
    container.classList.add('prices-container--fliped');
  }
}


function updateVolumePricingTables() {
  console.log("updateVolumePricingTables");
  const exVatColumns = document.querySelectorAll('.column__ex-vat');
  const incVatColumns = document.querySelectorAll('.column__inc-vat');

  if('vatIncluded' in sessionStorage) vatIncluded = sessionStorage.getItem('vatIncluded');
  else vatIncluded = 'false';

  if(vatIncluded == 'true') {
    exVatColumns.forEach((column) => {
      column.classList.add('hidden');
    });
    incVatColumns.forEach((column) => {
      column.classList.remove('hidden');
    });
  }
  else{
    exVatColumns.forEach((column) => {
      column.classList.remove('hidden');
    });
    incVatColumns.forEach((column) => {
      column.classList.add('hidden');
    });
  }
}

function updateVAT(){
  updateSwitch();
  updateVATPrices();
  updateVolumePricingTables();
}

window.addEventListener('DOMContentLoaded', updateVAT);

document.addEventListener("DOMContentLoaded", function () {
  const searchBar = document.querySelector(".live-search");

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;  

  function handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (window.innerWidth <= 680) {
      if (currentScrollTop > lastScrollTop) {
        // Scrolling down
        searchBar?.classList.add("hide-on-scroll");
      } else {
        // Scrolling up
        searchBar?.classList.remove("hide-on-scroll");
      }
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(handleScroll);
      ticking = true;
    }
  });
});


document.addEventListener("click", (e) => {
  const plus = e.target.closest("[data-quantity-plus]");
  const minus = e.target.closest("[data-quantity-minus]");
  if (!plus && !minus) return;

  const root = e.target.closest("[data-quantity-selector]") || e.target.closest("quantity-selector");
  if (!root) return;

  const input = root.querySelector("[data-quantity-input]");
  if (!input) return;

  const step = parseInt(input.getAttribute("data-increment-value") || input.step || "1", 10) || 1;
  const min = parseInt(input.min || "1", 10) || 1;

  let val = parseInt(input.value || String(min), 10);
  if (Number.isNaN(val)) val = min;

  if (plus) val += step;
  if (minus) val = Math.max(min, val - step);

  input.value = String(val);
  input.dispatchEvent(new Event("change", { bubbles: true }));
});


// New back to top button function
const backToTopWrapper = document.querySelector('[data-back-to-top]');

if (backToTopWrapper) {
  backToTopWrapper.addEventListener('click', (event) => {
    event.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}


/**
 * Updates Sami Wholesale table prices based on VAT toggle
 * @param {string} state - 'true' or 'false'
 */
function syncSamiWithVAT(state) {
  const taxRate = 1.2; // 20% VAT
  // This targets the second <td> inside rows that have the Sami attribute
  const samiPriceCells = document.querySelectorAll('tr[samiws-pricingrow-index] td:last-child');

  samiPriceCells.forEach(cell => {
    // 1. Get or set the original price to avoid compounding math
    let originalPrice = cell.getAttribute('data-original-price');

    if (!originalPrice) {
      // Clean text: "£5.08" -> "5.08"
      originalPrice = parseFloat(cell.innerText.replace(/[^0-9.]/g, ''));
      cell.setAttribute('data-original-price', originalPrice);
    }

    // 2. Calculate new price
    let calculatedPrice = (state === 'true') 
      ? parseFloat(originalPrice) * taxRate 
      : parseFloat(originalPrice);

    // 3. Format back to currency
    if (!isNaN(calculatedPrice)) {
        cell.innerText = '£' + calculatedPrice.toFixed(2);
    }
  });
}

/**
 * Updates Sami Wholesale table prices and header text based on VAT toggle
 * @param {string} state - 'true' or 'false'
 */
function syncSamiWithVAT(state) {
  const taxRate = 1.2;
  const samiPriceCells = document.querySelectorAll('tr[samiws-pricingrow-index] td:last-child');
  const tableHeader = document.querySelector('.samitaWS-responsive thead th:nth-child(2)');

  // Update Header
  if (tableHeader) {
    tableHeader.innerText = (state === 'true') ? 'Price (Inc VAT)' : 'Price (Ex VAT)';
  }

  samiPriceCells.forEach(cell => {
    let priceStored = cell.getAttribute('data-base-price');

    if (!priceStored) {
      // The app gave us £5.08. We need the Ex VAT version (£4.23) as our "base"
      let appPrice = parseFloat(cell.innerText.replace(/[^0-9.]/g, ''));
      // If the app is currently showing INC prices, divide by 1.2 to get the base
      priceStored = appPrice / taxRate; 
      cell.setAttribute('data-base-price', priceStored);
    }

    let finalPrice = (state === 'true') 
      ? parseFloat(priceStored) * taxRate 
      : parseFloat(priceStored);

    cell.innerText = '£' + finalPrice.toFixed(2);
  });
}

// You would call this function whenever the cart drawer opens


/**
 * Fixes Sami Table when it incorrectly starts with Inc VAT values
 */
function fixSamiInitialMath() {
  const taxRate = 1.2;
  const samiPriceCells = document.querySelectorAll('tr[samiws-pricingrow-index] td:last-child');

  samiPriceCells.forEach(cell => {
    let currentDisplayPrice = parseFloat(cell.innerText.replace(/[^0-9.]/g, ''));
    
    // Reverse the tax to find the true Ex VAT base price
    // £5.08 / 1.2 = £4.23
    let trueExVat = currentDisplayPrice / taxRate;

    // Store this "Correct" Ex VAT price as the source of truth
    cell.setAttribute('data-original-price', trueExVat.toFixed(2));
    
    // Set the initial display based on the current toggle state
    const currentState = sessionStorage.getItem('vatIncluded') || 'true';
    let initialPrice = (currentState === 'true') ? currentDisplayPrice : trueExVat;
    
    cell.innerText = '£' + initialPrice.toFixed(2);
  });
}

// Sami table takes a moment to inject into the page
setTimeout(fixSamiInitialMath, 2000);


/**
 * Watches for the Sami Table to load and forces the correct VAT state
 */
const observer = new MutationObserver((mutations) => {
  const samiTable = document.querySelector('tr[samiws-pricingrow-index]');
  
  if (samiTable) {
    console.log("Sami Table detected. Syncing VAT...");
    // Get the current toggle state from your session storage
    const currentState = sessionStorage.getItem('vatIncluded') || 'false';
    syncSamiWithVAT(currentState);
    
    // Once we've fixed it once, we can stop watching to save performance
    observer.disconnect();
  }
});

// Start observing the body for the app's table injection
observer.observe(document.body, { childList: true, subtree: true });